import { PropsWithChildren, useEffect, useState } from "react";
import theme from "../theme";

export const Loader = ({
  type = "spinner",
  children,
  id,
  dot = ".",
  dotInterval = 700,
  dotMaxLength = 3,
  showDots = true,
  borderColor = "primary",
}: {
  type?: "spinner" | "text";
  id?: string;
  children?: PropsWithChildren["children"];
  dot?: string;
  dotInterval?: number;
  dotMaxLength?: number;
  showDots?: boolean;
  borderColor?: keyof (typeof theme)["extend"]["colors"];
}) => {
  const [extraText, setExtraText] = useState(dot);
  useEffect(() => {
    if (!showDots) {
      return;
    }
    const intervalId = setInterval(() => {
      setExtraText((extraText) =>
        extraText.length >= dotMaxLength ? dot : extraText + dot
      );
    }, dotInterval);
    return () => {
      clearInterval(intervalId);
    };
  }, [setExtraText, dotInterval, dotMaxLength, dot, showDots]);
  return (
    <>
      <div
        className={
          type === "spinner"
            ? " animate-spin rounded-full center border-2 border-solid border-b-transparent w-5 h-5 inline-block border-box " +
              ("border-" + borderColor) +
              " "
            : ""
        }
        id={id}
      ></div>
      {children ? (
        <>
          {children}
          {showDots ? extraText : null}
        </>
      ) : null}
    </>
  );
};
